import React, { useState,useContext, useEffect } from "react";
import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Stack,
  InputLabel,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Card,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { carCompanyActions } from "../../service/carCompany.actios";
import "../carCompany/carCompany.css";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FileSaver from "file-saver";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { GlobalContext } from  "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { useTranslation } from "react-i18next";
import CustomLoader from "../../../../util/component/CustomLoader";
import GenericFilterBox from "../common/GenericFilterBox";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { IServerSideGetRowsParams } from "ag-grid-community";
import { GenericTitleHeader } from "../common/GenericTitleHeader";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

const CarCompanyTable = () => {
  
  const [gridApi, setGridApi] = useState<any>(null);
  let pageSize:number=10;
  
  const [length, setLength] = useState<number>(0);
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>(false);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const {tenant} = useContext(ContextOperation);
  const [dataForm, setData] = useState<any>({
    descr: "",
    code: "",
  });
  const { t } = useTranslation(["operation"]);
  const carCompanyAction = carCompanyActions();
  const columns: any = [
    {
      field: "descr",
      headerName: t("carRange.description"),
      flex: 1,
    },
    {
      field: "code",
      headerName: t("carRange.code"),
      flex: 1,
    },
    {
      field: "id",
      headerName: "Id",
      disableColumnMenu: true,
      hide: true,
      headerClassName: "titleOfHeader",
      flex: 1,
      sortable: false,
    },
  ];
  const handleChange = (event: any, type: any) => {
    setData({ ...dataForm, [type]: event.target.value });
  };

  function managerData(response: any) {
      let rows: any[] = [];
      response.data.content.forEach((element: any) => {
        let row = {
          code: element.code,
          descr: element.descr,
          id: element.id,
        };
        rows.push(row);
      });
      return rows;
  }

  const SearchCategories =(e:any)=>{
    e.preventDefault();
    setResetForm(!resetForm);
    
  }

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  const getEquipmentQueryParams = (
  ) => {
    let descr = !!dataForm.descr? dataForm.descr.trim() : null;
    let code = !!dataForm.code? dataForm.code.trim() : null;
    setIsLoading(true);
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        
        if (endRow !== null && endRow !== undefined && startRow !== null && startRow !== undefined) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize
    carCompanyAction
      .getCarCompanyQueryParams(pageNumber, pageSize,tenant, descr, code)
      .then((response: any) => {
        params.successCallback(
          managerData(response),
          response.data.totalElements
          
        );
        // if(length <= response.data.totalElements)
        // {
          setLength(response.data.totalElements)
        // } 
        setIsLoading(false);

      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:(error.response.data.error),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
        setIsLoading(false);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:(t("networkErrorMessage")),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
        setIsLoading(false);
        } else {
          setIsLoading(false);
        }
        setIsLoading(false);
      });
  
      }
    }
  };


  function exportEquipment() {
    setIsLoading(true);
    let descr = !!dataForm.descr? dataForm.descr.trim() : null;
    let code = !!dataForm.code? dataForm.code.trim() : null;
    carCompanyAction
      .exportData(tenant,descr, code)
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response?.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  }

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(
      getEquipmentQueryParams());
    }
  }, [gridApi,resetForm]);

  const reset = () => {
    setData({
      descr: "",
      code: "",
    });
    setResetForm(!resetForm);
  };

  return (
    <Box>
        <SectionHeader
            title={t("carCompany.titleFirst") + " " + t("carCompany.titleSecond")}
        />
      <Box >
        <form id="idCompanyForm" onSubmit={(e)=>SearchCategories(e)}>
          <GenericFilterBox formId="idCompanyForm" onReset={reset} showExtrasFilters={false}>
        
              <Box>
               
                <TextField
                  fullWidth
                  variant="standard"
                  
                  id="descr"
                  name="descr"
                  //placeholder={t("carRange.descriptionLabel")}
                  label={t("carCompany.description")}
                  value={dataForm.descr}
                  onChange={(event:any) => handleChange(event, "descr")}
                  inputProps={{
                    pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                     onInput: (event:any) => { 
                      if (event.currentTarget.validity.patternMismatch) 
                     { event.currentTarget.setCustomValidity(t("vehicle.filterModal.regexMessage"))
                    }else {
                      event.currentTarget.setCustomValidity('')
                    }
                    }
                  }}
                />
              </Box>
           
              <Box>
                <TextField
                  fullWidth
                  id="code"
                  name="code"
                  defaultValue="Brand code"
                  //placeholder={t("carRange.codeLabel")}
                  label={t("carCompany.code")}
                  value={dataForm.code}
                  onChange={(event:any) => handleChange(event, "code")}
                  variant="standard"
                  inputProps={{
                    pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                     onInput: (event:any) => { 
                      if (event.currentTarget.validity.patternMismatch) 
                     { event.currentTarget.setCustomValidity(t("vehicle.filterModal.regexMessage"))
                    }else {
                      event.currentTarget.setCustomValidity('')
                    }
                    }
                  }}
                />
              </Box>
          </GenericFilterBox>
        </form>
      </Box>

      <Box className="carBrandOuterTableBox">
      <Box>
        <Card >    
            <Box minHeight={46} pr={1} display="flex" justifyContent={'flex-end'} alignItems="center" >
            <Tooltip  title={t("tooltipTitle.download")}>
            <IconButton color="accent" disabled ={length === 0 ?true:false} onClick ={exportEquipment}>
          <FileDownloadIcon/>
          </IconButton>
          </Tooltip>
          </Box>       
        </Card>
        </Box>
        <Box>
          <AgGridOperationTable
            columnDefs={columns}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
            totalElements={length}
          />
        </Box>
        {loading && <CustomLoader loading={loading}/>}
      </Box>
    </Box>
  );
};
export default CarCompanyTable;
